module.exports = __webpack_public_path__ + "static/media/ic_menu.52facca4.svg";